
<script>
  
import Layout from "../../layouts/main";
import OrdersApi from "@/services/orders-api";
import VueBarcode from 'vue-barcode';




export default ({
  name: "success-order-paiment",
  components: {
    Layout, VueBarcode
  },


  data() {
      return {
        isOrderLoading : false ,
        order:{ref:null},
        showError: false,
      }
  },

  props: {
    order_s_ref:String,
    orderId:String

  },
  computed: {
    currentUser() {
        return this.$store.getters['auth/currentUser'];
    },

    userFullName() {
         return this.currentUser && this.currentUser.fullName ? this.currentUser.fullName : '';
        },

  },


  mounted(){

    this.getOrderByPaymentRef()
    this.getOrderBySpecialRef()

  },
  methods:{

    getOrderByPaymentRef(){
      if(this.orderId == 'undefined' || !this.orderId){
            return null
        }
        this.isOrderLoading = true ,
      OrdersApi.getOrderByPaymentRef(this.orderId)
      .then(order => {
        if(order){
          this.order = order;
          this.$store.commit('setGiftCode', this.order.giftCode);


        }
   
      })

      .finally(() => {
        this.isOrderLoading = false 
      })
      },


    getOrderBySpecialRef() {
        if(this.order_s_ref == 'undefined' || !this.order_s_ref){
            return null
        }

          this.isOrderLoading = true ,
        OrdersApi.getOrderBySpecialRef(this.order_s_ref)
        .then(order => {
          this.order = order;
          this.$store.commit('setGiftCode', this.order.giftCode);

        })

        .finally(() => {
          this.isOrderLoading = false 
        })
        },

        statusToLabel(status) {
      switch(status) {
        case 0: return 'cash';
        case 1: return 'cart';
       
        default: return '';
      }
    },


  }



})
</script>

<template>
  <Layout>

      <div class="payment-card"> 
        <div class="card-body ">

            <div class="text-center">
                <img class="mb-2" src="@/assets/images/logo.png"  >
                <div class="text-dark text-center font-size-18  mt-3 mb-2">Merci pour votre achat !</div>
                <div class="text-dark text-center font-size-18  mb-2">Nous sommes heureux que vous ayez choisi <strong>HA</strong></div>
            </div>

            <div class="col-12 mt-5 mb-5" style="background-color: black; height: 6px; width: 100%;" />
            <div v-if="this.order" class="text-left font-size-16" >
                

                <div class="text-dark font-size-22 font-weight-bold mt-5 ">COMMANDE N° <strong>{{ order.ref }}  </strong></div>
                <div class="mt-2 text-dark" ><strong>{{ order.date }}  </strong> </div>
                <div class="mt-1 text-dark">Paiement <strong> {{$t("paymentMethodes."+statusToLabel( order.paymentMethod))}} </strong></div>
              
                <div class="text-dark font-size-20 font-weight-bold  mt-4 pt-2">CLIENT</div>
                <div class="mt-2 text-dark"><strong>{{ order.customerName }}  </strong>  </div>
                <div class="mt-1 text-dark">Téléphone : <strong>{{ order.customerPhone }}  </strong></div>
                <div class="mt-1 text-dark">E-mail : <strong>{{ order.customerMail }}  </strong> </div>
                <div class="mt-1 text-dark">Adresse de Livraison : <strong>{{ order.deliveryAddress }}  </strong> </div>

            </div>

            <div v-if="order && order.lines" class="col-12 mt-5 pt-3">  

                <div class="row s-header d-none d-print-flex d-lg-flex">
            <div class="col-4 s-titles text-left">CODE A BARRE</div>
            <div class="col-8">
              <div class="row">
                <div   class="col-7 ">
                  <div class="s-titles text-left d-none d-sm-block">ARTICLE</div>
                </div>
                <div class="col-5">
                  <div class="s-titles text-right d-none d-sm-block">PRIX</div>
                </div>
              </div>
            </div>
            
            
            </div>
               
        <!-- Items rows --> 
        <div v-for="(item, index) in order.lines" :key="index" class="row item-row pt-2 pb-2 mr-0 ml-0" >
            <!-- Web Version -->
            <div class="col-4 text-left d-none d-print-block d-lg-block">
                <div class="product-info">
                    <vue-barcode
                    v-if="item.itemVariantBarcode"
                        :value="item.itemVariantBarcode"
                        :width="1"  :height="50" 
                        background="transparent"
                        fontSize="16" >
                      </vue-barcode>
                    </div>
            </div>
            <div class="col-lg-8 col-8-for-print ">
                <div class="row  mt-2">
                <div   class="col-7 pb-3 ">
                    <div class="font-size-16 font-weight-bold ">
                        <span v-if="item.itemVariantBarcode" > {{  item.quantity }} x</span>
                        <span class="ml-2 text-dark">{{  item.itemTitle }}</span>
                    </div>
                    <div v-if="item.itemVariantBarcode" class="ml-4">
                        <div >Ref:  {{item.ref }}</div>
                        <div   class="pb-3 font-size-12 ">TAILLE :  {{item.size }},<span class="ml-1"> COULEUR : {{item.color }} </span></div>


                    </div>
                   </div>
            <div class=" font-size-16 col-5 font-weight-bold text-right text-dark">{{ item.discountedPrice }}</div>

            </div> 

            </div>       
                
        </div>
        <div class="row mt-4" style="border-top:1px solid #cbcbcb;"> 
            <div class="col-6 d-none d-print-flex d-lg-flex"/>
            <div class=" col-lg-6 col-6-for-print elementscartcoupon p-0 p-md-2 p-lg-3">
                <div class="cartSummary1 mb-2 mt-3">Commande</div>
                <div class="contentsecond">
                    <div class="itemFields">
                        <div class="elementSummaryinfoFi mt-3">
                            <div class="content-5">
                                <div class="title-amount">
                                    <div class="titleFirst">
                                        <div class="freeShip text-dark">Sous Total</div>
                                    </div>
                                    <div class="value font-weight-normal text-dark">{{ order.totalBeforeDiscount }}</div>
                                </div>
                            </div>
                        </div>
                       
                        <div v-if="order.discountAmount" class="elementSummaryinfoFi mt-3">
                            <div class="content-5">
                                <div class="title-amount">
                                    <div class="titleFirst">
                                        <div class="text-dark">
                                            Remise sur Panier 
                                         </div>
                                    </div>
                                    <div class="value font-weight-normal text-dark">{{ order.discountAmount }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="elementSummaryinfoFi1 mt-3">
                            <div class="content-5">
                                <div class="title-amount">
                                    <div class="labelFirst text-dark">Total</div>
                                    <div class="valueFirst text-dark">{{ order.total }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="order.giftCardAmount" class="elementSummaryinfoFi mt-4">
                            <div class="content-5">
                                <div class="title-amount">
                                    <div class="titleFirst">
                                        <div class="text-dark">
                                          {{ $t('giftCard.payment') }} 
                                         </div>
                                    </div>
                                    <div class="value font-weight-normal text-dark">{{ order.giftCardAmount }}</div>
                                </div>
                            </div>
                        </div>

                        <div v-if="order.finalAmountToPay" class="elementSummaryinfoFi1">
                            <div class="content-5">
                                <div class="title-amount">
                                    <div class="labelFirst text-dark">Net à payer</div>
                                    <div class="valueFirst text-dark">{{ order.finalAmountToPay }}</div>
                                </div>
                            </div>
                        </div>


                    </div>
                    
                </div>
            </div>

        </div>

        



        <div class="col-md-12  pt-3 text-right d-print-none" > 
                <a href="javascript:window.print()">
                    <b-button variant="light" style="width: 100%" size="lg" >
                      <img  alt="" class="align-middle mr-2" width="20px" src="../../../assets/icons/fi-rr-print.svg"  />  Imprimer
                    </b-button>
                  </a>
              </div>


    </div>
        </div>
      </div>
  </Layout>
</template>
        
<style >

@media print {
    .payment-card {
      margin:0px !important;
      padding-left: 10px !important;
      padding-right: 10px !important;
      border: 1px dashed #858383; 
      border-radius: 5px !important;
    }


  
}

.labelFirst {
    position: absolute;
    top: 0px;
    left: 0px;
    line-height: 30px;
    font-weight: 600;
}

.valueFirst {
    position: absolute;
    top: calc(50% - 13px);
    right: 0px;
    font-size: 16px;
    line-height: 26px;
    font-weight: 600;
    text-align: right;
}
.elementSummaryinfoFi {
    align-self: stretch;
    border-bottom: 1px solid #eaeaea;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 13px 0px;
}

.value {
    position: absolute;
    top: calc(50% - 13px);
    right: 0px;
    line-height: 26px;
    font-weight: 600;
    text-align: right;
}
.elementSummaryinfoFi1 {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 13px 0px;
    font-size: 18px;
}
.freeShip {
    position: relative;
    line-height: 26px;
}
.titleFirst {
    position: absolute;
    top: calc(50% - 13px);
    left: 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}
.elementscartcoupon {
    width: 100%;
    border-radius:8px;
}


.cartSummary1 {
    align-self: stretch;
    position: relative;
    line-height: 34px;
    font-weight: 500;
    font-size: 22px;
    color: #121212;
}
.contentsecond {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 16px;
    font-family: Inter;
}
.itemFields {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0px 0px 20px;
}
.content-5 {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}
.title-amount {
    flex: 1;
    position: relative;
    height: 26px;
}

.underline-title-text {
      text-decoration: underline;
    }

.s-titles {
    flex: 1;
    position: relative;
    height: 28px;
    font-size: 16px;
    letter-spacing: -0.4px;
    line-height: 28px;
    font-weight: 500;
    font-family: 'Space Grotesk';
}

.s-header {
    display: flex;
    width: 100%;
    /*max-width: 960px;*/
    margin: 0 auto;
    border-bottom: 1px solid #cbcbcb;
    color:#121212;
}
</style>
        
        
<style scoped>



/* Web view */
@media only screen and (min-width: 601px) {
  .pageHeader {
    padding-top: 4%;
  }
}

/* Mobile view */
@media only screen and (max-width: 600px) {
  .pageHeader {
    padding-top: 15%;
  }
}

.image-container{
  border-radius: 15px;
  border: 1px solid #bbbaba;
  padding: 0px; 
  display: inline-block; 
}

@media only screen and (min-width: 1200px) {
  .payment-card {

    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    padding: 20px;
    margin: 3% 20% 0 20%;
    position: relative;
    overflow: hidden;
  }
}

@media only screen and (max-width: 1199px) {
  .payment-card {

    background-color: #ffffff;
    border-radius: 5px;
    margin: 0px;
    overflow: hidden;
  }
}

@media print {
  .col-8-for-print {
    width: 66.66667% !important; 
    float: left; 
  }
}

@media print {
    .col-6-for-print {
      width: 50% !important; 
      float: left;  
    }
}

/* .payment-card:hover {
box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4); 
} */

.payment-header{
font-size: 40px;
padding: 15px 0;
}
</style>